import { useEffect, useContext, useState } from "react";
import { languages } from "../../languages/languages";
import UserContext from "../../languages/UserContext";
import { First, Second, Third, Forth, Fifth } from "../../assets/bg/bgs";
import "./HeroBlock.scss";

const HeroBlock = () => {
  const user = useContext(UserContext);

  const backgrounds = [First, Second, Third, Forth, Fifth];

  const [condition, setCondition] = useState(0);

  const selectors = backgrounds.map((data, idx) => (
    <span
      key={idx}
      className={`selector ${condition === idx ? "selector--toggled" : ""}`}
      onClick={() => setCondition(idx)}
    ></span>
  ));
  const images = backgrounds.map((data, idx) => (
    <img
      key={idx}
      className={`hero-image ${condition === idx ? "hero-image--shown" : ""}`}
      src={backgrounds[idx]}
      alt=""
    ></img>
  ));

  useEffect(() => {
    let i = 0;
    const slideshow = () => {
      setCondition(i++ % 5);
    };
    const slider = () => {
      setInterval(slideshow, 5002);
    };
    slider();
  }, []);

  return (
    <section id="hero" className="hero">
      {images}

      <div className="title-wrap">
        <h1 className="hero-title">
          <strong> {languages[user.lang].HeroStrong}</strong>
          {languages[user.lang].HeroHeader}
        </h1>
        <a className="hero-explore" href="#project">
          <span> {languages[user.lang].HeroButton}</span>
        </a>
      </div>
      <div className="bg-selectors">
        <div className="selector-wrap">{selectors}</div>
      </div>
    </section>
  );
};

export default HeroBlock;
